import { inject, Injectable } from '@angular/core'

import { environment } from '@env'
import { RecaptchaState } from '@states/recaptcha-state'

declare const grecaptcha: any

@Injectable({
	providedIn: 'root',
})
export class RecaptchaService {
	readonly #recaptchaState = inject(RecaptchaState)

	refresh(): Promise<void> {
		return new Promise((resolve) => {
			grecaptcha.ready(() => {
				grecaptcha
					.execute(environment.reCaptcha.siteKey, { action: 'submit' })
					.then((token: string) => {
						this.#recaptchaState.token.set(token)
						resolve()
					})
			})
		})
	}
}
